/**
 * Created by jiachenpan on 16/11/18.
 */
import { updateMembershipStatus, updatePaymentStatus } from '@/api/user'
import Vue from 'vue'

import { Message } from 'element-ui'

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function parseState(value) {
  if (value === 0) {
    return '正常'
  } else {
    return '禁用'
  }
}

export const ImageFormat = {
  imageView: function (hash, w, h, mode, format) {
    mode = mode || 1
    let url = ''
    if (!hash) return false
    if (!hash.match(/^(http|https):/i)) {
      url = varConfig.qiniuCdn + '/' + hash
    } else {
      url = hash
    }
    if (url.match(/qiniucdn\.com/i) || url.match(/static\.bjh\.snsports\.cn/i) || url.match(/s\.bjhockey\.org/i) || url.match(/image\.bjh\.snsports\.cn/i)) {
      if (url.indexOf('?') < 0) {
        url = url + '?imageView2/' + mode + '/w/' + w + '/h/' + h
        if (format) {
          url += '/format/' + format
          if (format === 'jpg') {
            url += '/interlace/1'
          }
        }
      }
    }
    return url
  },
  squareImageView: function (hash, size, mode, format) {
    return this.imageView(hash, size, size, mode, format)
  },
  squareImageView1: function (hash, width, height, mode, format) {
    return this.imageView(hash, width, height, mode, format)
  },
  fileView: function (hash) {
    hash = hash || '';
    let url = ''
    if (!hash.match(/^(http|https):/i)) {
      url = varConfig.qiniuCdn + '/' + hash
    } else {
      url = hash
    }
    return url
  },
}

export const ConstConfig = {
  apiPath: '/api/content/pc',
  wxAppId: 'wx83d351356eb8c592',
  accept: 'image/jpeg,image/gif,image/png,image/bmp',
  acceptVideo: 'video/mp4,video/mpeg4',
  acceptXls: '*/xls',
  certificateType: [{ name: '身份证', id: 1 }, { name: '护照', id: 2 }, { name: '港澳台居民居住证', id: 5 }, { name: '港澳居民来往内地通行证', id: 6 }]
}

export const varConfig = {
  qiniuCdn: process.env.QINIU_CDN,
  qiniuUp: process.env.QINIU_UP,
  baseApi: process.env.BJH_API
}

if (enableHttps()) {
  // dev, prod urls
}
function enableHttps() {
  return window.location.protocol === 'https:'
}

export function showMessage(type, message) {
  Message({
    message: message,
    type: type,
    showClose: true,
    duration: 1000
  })
}

export function getDateObjectByString(dateString) { // 为了兼容ios的时间格式转化
  if (dateString) {
    var convertedDateString = dateString.replace(/-/g, "/").replace("T", " ").replace(/\+[0-9:]+/ig, "");
    return new Date(convertedDateString);
  }
}

// 把修改状态和付费状态封装成一个公共方法
/*
export const AuditStatus = {
  paymentStatusParams: {
    id: null,
    status: null,
    remark: null
  },
  revise: function(type, status) {
    const vm = this
    return new Promise((resolve, reject) => {
      const params = vm.paymentStatusParams = {
        id: status.row.id,
        status: status.row.status,
        remark: '' // TODO
      }
      if (type === 'payment') {
        params.paymentStatus = status.row.paymentStatus
        if (status.row.paymentStatus === 2) {
          this.dialogVisibleSelectTime = true
        } else {
          vm.updatePaymentStatus(params)
        }
      } else if (type === 'audit') {
        if (status.row.status === 1) {
          reject({ status: 1 })
        } else {
          vm.updateMembershipStatus(params)
        }
      }
    })
  },
  updateMembershipStatus: function(param) {
    const params = param
    updateMembershipStatus(params).then((resolve) => {
      Message({
        message: '审核状态修改成功',
        type: 'success'
      })
    }, (reject) => {
      Message({
        message: '审核状态修改失败',
        type: 'error'
      })
    })
  }
}*/
